import React from 'react';
import usePageTitle from '../../hooks/usePageTitle';

/**
 * Route'lara dinamik sayfa başlığı ekleyen wrapper bileşen.
 * 
 * Kullanım:
 *   <Route path="/projects" element={
 *     <PageTitle title="Projeler">
 *       <ProjectList />
 *     </PageTitle>
 *   } />
 */
const PageTitle = ({ title, children }) => {
  usePageTitle(title);
  return children;
};

export default PageTitle;
